<div class="modal-content">
  <div class="modal-header">
    <h1 class="modal-title pull-left" aria-hidden="true">
      {{ "BURRIAL_POPUP_TITLE" | globalTranslate }}
    </h1>
    <button
      type="button"
      class="btn-close pull-right"
      [attr.aria-label]="'CLOSE' | globalTranslate"
      (click)="onCancel()"
    >
      <img
        src="../../assets/images/⚛️ icons-close-circle-outline.svg"
        alt="close-icon"
      />
    </button>
  </div>
  <div class="modal-body">
    <h2 class="page-header sr-only" role="heading" aria-level="1">
      {{ "BURRIAL_POPUP_TITLE" | globalTranslate }}
    </h2>
    <h2 class="section-header">
      {{ "BURRIAL_POPUP_TITLE" | globalTranslate }}
    </h2>
    <hr />

    @if (translatedLang === 'en') {
    <p>
      <b [innerHTML]="'BURRIAL_POPUP_STATIC1' | globalTranslate"></b>
      <span [innerHTML]="'BURRIAL_POPUP_STATIC1_01' | globalTranslate"></span>
      <b [innerHTML]="'BURRIAL_POPUP_STATIC1_02' | globalTranslate"></b>
      <span [innerHTML]="'BURRIAL_POPUP_STATIC1_03' | globalTranslate"></span>
    </p>
    } @if (translatedLang === 'sp') {
    <p>
      <b [innerHTML]="'BURRIAL_POPUP_STATIC1' | globalTranslate"></b>
      <span [innerHTML]="'BURRIAL_POPUP_STATIC1_04' | globalTranslate"></span>
    </p>
    }

    <p>
      <b [innerHTML]="'BURRIAL_POPUP_STATIC2' | globalTranslate"></b>
      <span [innerHTML]="'BURRIAL_POPUP_STATIC2_01' | globalTranslate"></span
      >&nbsp;
      <b [innerHTML]="'BURRIAL_POPUP_STATIC2_02' | globalTranslate"></b>
      <span [innerHTML]="'BURRIAL_POPUP_STATIC2_03' | globalTranslate"></span>
    </p>
  </div>
</div>